import { render, staticRenderFns } from "./ModalOnboarding.vue?vue&type=template&id=b3246f24&scoped=true&"
import script from "./ModalOnboarding.vue?vue&type=script&lang=js&"
export * from "./ModalOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./ModalOnboarding.vue?vue&type=style&index=0&id=b3246f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3246f24",
  null
  
)

export default component.exports